import { Component, Input, OnInit } from '@angular/core';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';

@Component({
  selector: 'app-patient-manifestrx-plan',
  templateUrl: './patient-manifestrx-plan.component.html',
  styleUrls: ['./patient-manifestrx-plan.component.scss']
})
export class PatientManifestrxPlanComponent implements OnInit {
  selectedPlan: string = 'Manifest Rx';

@Input() planName: string;

  constructor(
            private patientService:PatientService,
            private utils: UtilsService,
            
  ) { }

  ngOnInit() {
  }
  SSOSignIn(): void {
    console.log('Selected Plan:', this.selectedPlan); // Console log the selected plan


    this.patientService.getSSOSignIn(this.planName).subscribe(
      (response: any) => {
        console.log("API Response:", response.result);
     
        if (response.resultStatus.isSuccess) {
          const blob = new Blob([response.result], { type: "text/html" });
          const url = URL.createObjectURL(blob);
          window.open(url, "_blank"); // Open in a new tab
        } else {
          const errorMessage = response && response.resultStatus && response.resultStatus.errorMessages
          ? response.resultStatus.errorMessages.join(", ")
          : "Failed to fetch subscription details.";
        
        this.utils.showMessageSnackBar(errorMessage, true);        }
      },
      (error) => {
        console.error("API Error:", error);
      }
    );
  }
}
